export const CUSTOM_PACKAGE_REQUEST_PATH = '/forms/custom-booking/:formID';
export const RSVP_FORM_PATH = '/forms/rsvp-form/:formID';
export const VENDOR_FORM_PATH = '/vendor-form/:formID';
export const VENDOR_FORM_EXTENDED_PATH = '/vendor-form-extended/:formID';
export const PRIVATE_VIEW_PATH = '/private-view';
export const SUCCESS_VIEW_PATH = '/success-view';
export const NO_MORE_RESPONSES_VIEW_PATH = '/not-accepting-submissions';
export const NO_MATCH_404_PATH = '*';
export const NO_MORE_RESPONSES_RSVP_VIEW_PATH = '/not-accepting-rsvp-submissions';
